import { render } from "./WalletInstrumentTypeSummaryCard.vue?vue&type=template&id=3527e3fc&scoped=true"
import script from "./WalletInstrumentTypeSummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletInstrumentTypeSummaryCard.vue?vue&type=script&lang=js"

import "./WalletInstrumentTypeSummaryCard.vue?vue&type=style&index=0&id=3527e3fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3527e3fc"]])

export default __exports__